import React, { useEffect, useState } from "react";
import BoxPayGrid from "../BoxPayGrid";
import { useAuth } from "../../context/API_Client";
import { BusinessUnitsSchema } from "./businessUnitsSchema";
import CreateBusinessUnit from "./createBusinessUnit";
import EmptyState from "../../reusableComponents/ConfigEmptyState/EmptyState";
import LoadingLogoPage from "../loadingPage/loadingPage";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import { convertIsoToGivenDateFormat } from "../utils/utils";
import ContentHeader from "../../reusableComponents/contentHeader/ContentHeader";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import { colorBrandObject } from "../../../constants/brandings";

function BusinessUnit(operationPermissions) {
  const { getBusinessUnits, isAuthorizedPermission, merchantSettings } =
    useAuth();
  const [gridData, setGridData] = useState([]);
  const [open, setOpen] = useState(false);
  const [createdUnit, setCreatedUnit] = useState(false);

  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [selectedWebsiteAddress, setSelectedWebsiteAddress] = useState("");
  const [selectedDescription, setSelectedDescription] = useState("");
  const [selectedVersion, setSelectedVersion] = useState("");

  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [timeZone, setTimeZone] = useState(null);

  const handleOpen = () => {
    setEditing(false);
    setSelectedBusinessUnit("");
    setSelectedCode("");
    setSelectedDescription("");
    setSelectedWebsiteAddress("");
    setOpen(true);
  };

  const handleClose = (event) => {
    setSelectedBusinessUnit("");
    setSelectedCode("");
    setSelectedDescription("");
    setSelectedWebsiteAddress("");
    setSelectedVersion("");
    setOpen(false);
  };

  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
      },
      function (errorMsg) {}
    );
  }, []);
  useEffect(() => {
    if (timeZone) {
      getBusinessUnits(
        function (data) {
          const filteredData = data?.map((rawData) => {
            const epochValue = rawData.addedDTime;
            const outputDatetimeStr = convertIsoToGivenDateFormat(
              epochValue,
              timeZone
            );
            rawData["addedDTime"] = outputDatetimeStr;

            return rawData;
          });
          setGridData(filteredData);
          setLoading(false);
        },
        function (errorMsg) {
          customToast("error", "high", errorMsg);
        }
      );
    }
  }, [createdUnit, timeZone]);

  const handleEdit = (data) => {
    setEditing(true);
    setSelectedBusinessUnit(data?.name);
    setSelectedCode(data?.code);
    setSelectedDescription(data?.description);
    setSelectedWebsiteAddress(data?.websiteAddress);
    setSelectedVersion(data?.version);
    setOpen(true);
  };
  return (
    <>
      {loading ? (
        <div className="content-wrapper" style={{ background: "white" }}>
          <section
            className="content"
            style={{
              top: "50%",
              left: "50%",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingLogoPage />
          </section>
        </div>
      ) : (
        <div className="content-wrapper" style={{ background: "white" }}>
          <section className="content">
            {gridData?.length > 0 ? (
              <>
                <ContentHeader
                  firstHeading="Business Units"
                  secondHeading="A business unit enables customized payment experiences for diverse regions, currencies, and checkout processes, supporting multiple payment methods effectively."
                  buttonPermissions={[
                    operationPermissions?.createLegalEntity,
                    operationPermissions?.businessUnitsPresent,
                  ]}
                  icon={<BusinessCenterOutlinedIcon sx={{color:colorBrandObject.sideBarSelectedOptionBackground}}  />}
                  buttonText="Create Business Unit"
                  buttonType="primary"
                  buttonSize="md"
                  buttonVariant="contained"
                  buttonOnclick={handleOpen}
                  contentWidth={"85%"}
                />
                <div
                  style={{ width: "100%", display: "flex", marginTop: "32px" }}
                >
                  <BoxPayGrid
                    schema={BusinessUnitsSchema(
                      handleEdit,
                      operationPermissions
                    )}
                    data={gridData}
                    showCustomizeButton={false}
                  ></BoxPayGrid>
                </div>
              </>
            ) : (
              <div className="routing-root-container">
                <EmptyState
                  image={
                    <BusinessCenterOutlinedIcon
                      sx={{
                        color: "rgba(201, 201, 204, 1)",
                        height: "120px",
                        width: "120px",
                      }}
                    />
                  }
                  mainText={"Create Business Unit"}
                  subText={"Establish business unit for streamlined payments"}
                  btnText={"Create Business Unit"}
                  btnPermission={operationPermissions?.createLegalEntity}
                  btnFunction={handleOpen}
                />
              </div>
            )}
          </section>
        </div>
      )}
      <CreateBusinessUnit
        open={open}
        onClose={handleClose}
        createdUnit={createdUnit}
        setCreatedUnit={setCreatedUnit}
        selectedBusinessUnit={selectedBusinessUnit}
        selectedCode={selectedCode}
        selectedWebsiteAddress={selectedWebsiteAddress}
        selectedDescription={selectedDescription}
        selectedVersion={selectedVersion}
        editing={editing}
      />
    </>
  );
}

export default BusinessUnit;
